import { observer } from "mobx-react";
import exchangeInterfaceStore from "../../../stores/ExchangeInterfaceStore";
import { ESTIMATED_TRANSACTION_FEES } from "../../../utils/constants";

const ErrorText = () => {
  const { statuses, activePaymentMethod } =
    exchangeInterfaceStore;

    const textClasses = {
        red: "text-red-500",
        green: "text-green-800",
        blue: "text-blue-800"
    }

    if(statuses.BELOW_MINIMUM){
      return (
        <Text classes={textClasses.red} text={`Minimum buy is 1666.66 $PEPE3D tokens ( ≈ 5 USD).`}/>
      );
    }

    if(statuses.NOT_ENOUGH_BALANCE){
      return (
          <Text classes={textClasses.red} text={`Not enough ${activePaymentMethod} to pay for the transaction.`}/> 
      )
   }

    if (statuses.NOT_ENOUGH_FEES) {
        return (
          <Text classes={textClasses.red} text={`${ESTIMATED_TRANSACTION_FEES} BNB is needed to pay for the gas fee.`}/>
        );
      }



     if(statuses.NOT_ENOUGH_TOKENS){
      return (
          <Text classes={textClasses.red} text={`Not enough tokens for sale in the contract.`}/> 
      )
   }
      return <></>
};

const Text = observer(({ classes, text }: { classes: string; text: string }) => {
  return <span className={` text-md font-semibold text-center  ${classes}`}>{text}</span>;
});

export default observer(ErrorText);
